import * as React from 'react';

import { registerComponent } from '@avensia/excite';
import { styled } from '@glitz/react';
import Image from 'webapp/components/image';
import { createMaxSmallViewportDecorator, createMinMediumViewportDecorator } from 'webapp/viewport';
import { Block, maxContentExtraNarrowWidthDecorator } from 'webapp/components/page-layout';
import { isSvenssons } from 'webapp/theme';

export default registerComponent<NordicNest.Api.AutherBlock>(AutherBlock);

function AutherBlock({ image, autherName, email, marginBottom }: NordicNest.Api.AutherBlock) {
  return (
    <Base css={marginBottom && marginDecorator}>
      <AutherImage image={image} />
      <Auther>
        <Name>{autherName}</Name>
        <Email>{email}</Email>
      </Auther>
    </Base>
  );
}

const Base = styled(
  Block,
  maxContentExtraNarrowWidthDecorator,
  createMaxSmallViewportDecorator({
    padding: { x: t => t.spacing.m },
  }),
  {
    display: 'flex',
    alignItems: 'center',
  },
);

const marginDecorator = styled(
  createMaxSmallViewportDecorator({
    marginBottom: t => t.spacing.l,
  }),
  {
    marginBottom: t => t.spacing.xxl,
  },
);

const AutherImage = styled(
  Image,
  createMinMediumViewportDecorator({
    maxWidth: 80,
    maxHeight: 80,
  }),
  {
    maxWidth: 40,
    maxHeight: 40,
    objectFit: 'cover',
  },
);

const Auther = styled.div(
  createMinMediumViewportDecorator({
    marginLeft: t => t.spacing.l,
  }),
  {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: t => t.sharedSpacing.m,
  },
  !isSvenssons && {
    fontWeight: t => t.fontWeight?.bold,
  },
);

const Name = styled.div({
  fontSize: t => (isSvenssons ? t.fontSize.s : t.fontSize.m),
});

const Email = styled.div({
  fontSize: t => t.fontSize.xxs,
});
